import Form from "@components/Form"
import { Box, Container, Heading } from "@chakra-ui/react"
import React from "react"

const FormSection: React.FC<GatsbyTypes.SanitySectionForm> = ({ title, form, buttonText }) => {
  const formHandle = form?.handle?.current || "default"

  return (
    <Container w={["unset", "648px"]} minW={"unset"} p={["0px", "0px"]}>
      <Box id={formHandle}>
        <Container px={[2, "0 !important"]}>
          {title && (
            <Heading as="p" mb={[4, 4, 8]} textAlign={"center"}>
              {title}
            </Heading>
          )}
          <Form formHandle={formHandle} buttonText={buttonText} />
        </Container>
      </Box>
    </Container>
  )
}

export default React.memo(FormSection)
